/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { AppService } from '@services/app/app.service';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ModalStateComponent } from './../modal-state/modal-state.component';
import { UiService } from '@services/ui/ui.service';
import { DestroyDirective } from '../destroy-abstract/destroy.abstract';
import { takeUntil } from 'rxjs/operators';
import { slideInAnimation } from '@core/animations';
import { ContentService } from '@services/content/content.service';

@Component({
  selector: 'app-step-header',
  templateUrl: './step-header.component.html',
  styleUrls: ['./step-header.component.scss']
})
export class StepHeaderComponent extends DestroyDirective implements OnInit {
  /**
   * disabilita i bottoni
   */
  @Input() disabled: boolean;

  /**
   * nasconde il bottone back
   */
  @Input() hideBack: boolean;

  /**
   * nasconde la barra di progresso
   */
  @Input() hideProgress: boolean;

  /**
   * titolo dell'header
   */
  @Input() title: string;

  /**
   * numero di step
   */
  @Input() totalSteps: number;

  /**
   * index step attivo
   */
  @Input() activeIndex = 0;

  /**
   * emette evento di back
   */
  @Output() back = new EventEmitter<void>();

  /**
   * nasconde bottone per modale di state
   */
  hideState: boolean;

  /**
   * url del logo
   */
  logoUrl: string;

  /**
   * flag per determinare la visualizzazione del logo
   */
  logoVisible: boolean;

  /**
   * flag che determina l'osservazione del wizard
   */
  absolute: boolean;

  /**
   * messaggio di intro per la applicazione
   */
  appIntroMessage: string;

  constructor(
    private uiService: UiService,
    private appService: AppService,
    private contentService: ContentService
  ) {
    super();
  }

  ngOnInit() {
    this.watchContentCode();
    this.readConfig();
  }

  /**
   * apre modale di state
   */
  async openState(): Promise<void> {
    await this.uiService.showModal<ModalStateComponent>({
      component: ModalStateComponent,
      cssClass: 'modal-page modal-state',
      enterAnimation: el => slideInAnimation(el, { direction: 'enter' }),
      leaveAnimation: el => slideInAnimation(el, { direction: 'leave' })
    });
  }

  /**
   * imposta messaggio di intro per la applicazione (per funzione ARIA)
   */
  private watchContentCode(): void {
    this.contentService
      .getContentPageWhenChange()
      .pipe(takeUntil(this.destroy$))
      .subscribe(page => {
        this.appIntroMessage =
          !!page && !!page.code ? `intro_${page.code}` : 'intro';
      });
  }

  /**
   * legge i valori del config
   */
  private readConfig(): void {
    const config = this.appService.getConfig();

    this.hideState = config.wizard.allowStateMenu !== true;
    this.logoUrl = config.theme.logoUrl;
    this.logoVisible = config.theme.logoOnHeader || false;
    this.absolute = config.wizard.progressBar === 'absolute';
  }
}
